export const UserTypes = {
    SIGN_IN: 'SIGN_IN',
    SIGN_OUT: 'SIGN_OUT',
    CAMBIAR_MODULO: 'CAMBIAR_MODULO',
    CAMBIAR_PUNTOS_POLIGONOS: 'CAMBIAR_PUNTOS_POLIGONOS',
    CAMBIAR_UBICACION: 'CAMBIAR_UBICACION',
    CAMBIAR_CONFIGURACION: 'CAMBIAR_CONFIGURATION'
}